module.exports = __webpack_public_path__ + "img/cross_white.b4c117fb.svg";